import { ISelectData } from 'components/atoms/SelectComponent';

import { EMatNelzeDuvod } from 'enums/lei/matNelzeDuvod';

export const leiMatNelzeDuvodSelect: ISelectData[] = [
    {
        labelcz: 'LEGAL_OBSTACLES',
        value: EMatNelzeDuvod.LEGAL_OBSTACLES
    },
    {
        labelcz: 'CONSENT_NOT_OBTAINED',
        value: EMatNelzeDuvod.CONSENT_NOT_OBTAINED
    },
    {
        labelcz: 'BINDING_LEGAL_COMMITMENTS',
        value: EMatNelzeDuvod.BINDING_LEGAL_COMMITMENTS
    },
    {
        labelcz: 'DETRIMENT_NOT_EXCLUDED',
        value: EMatNelzeDuvod.DETRIMENT_NOT_EXCLUDED
    },
    {
        labelcz: 'DISCLOSURE_DETRIMENTAL',
        value: EMatNelzeDuvod.DISCLOSURE_DETRIMENTAL
    }
];
